import { render, staticRenderFns } from "./McrFormB3.vue?vue&type=template&id=52e21fc5"
import script from "./McrFormB3.vue?vue&type=script&lang=js"
export * from "./McrFormB3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports